export default "__VITE_ASSET__82c37594__"